// extracted by mini-css-extract-plugin
export default {"container":"about_container__Vboo1","photos":"about_photos__lgdox","text":"about_text__qYLgr","textBox":"about_textBox__D1r9j","link":"about_link__thF1k"};